import { useQuery } from "@tanstack/react-query";
import { companyCommissionApi } from "@/lib/company-commission.api";
import { queryKeys } from "@/lib/query-keys";

export function useCompanyCommissionSuppliers() {
  return useQuery({
    queryKey: queryKeys.companyCommissionSuppliers(),
    queryFn: () => companyCommissionApi.listSuppliers().then((r) => r.data),
    staleTime: 60_000,
  });
}
